import React from 'react';

const ErrorPage = () => {
  return (
    <div className="error-container">
      <h1>Link Inválido</h1>
      <p>O link que você acessou é inválido. Por favor, verifique o link e tente novamente.</p>
    </div>
  );
};

export default ErrorPage;
